<template>
	<el-card class="ylDataCensus">
		<div class="yl_dataCensus_title" v-if="titleFlag">{{title}}</div>
		<el-row class="yl_dataCensus">
			<el-col :span="spanNum" class="dataCensus_li" v-for="(item, index) in list" :key="index">
				<div class="census_box">
					<p class="census_describe">{{item[field.name]}}</p>
					<p class="census_data ft24">{{item[field.code]}}</p>
				</div>
			</el-col>
		</el-row>
	</el-card>
</template>
<script>
import mixin from "./mixin"
export default {
	name: 'yl-lc-data-census',
	mixins:[mixin],
	props:{
		title:{
			type: String,
			default: ''
		},
		titleFlag:{
			type: Boolean,
			default: false
		},
		source:{
			type: Object,
			default:()=>{}
		}
	},
	data() {
		return {
			field:{},
			list:[]
		}
	},
	watch:{
		"source":{
            handler(source){
				if(source){
					this.field = source;
					let sourceData = this.resolveSource(source.body);
					if(sourceData.run){
						sourceData.run().then(res=>{
							this.list = res.data.data;
						})
					}else{
						this.list = sourceData;
					}
				}
            },
            immediate:true
        }
	},
	computed: {
		spanNum(){
			return 24/this.list.length || 24
		},
	},
	mounted() {
	},
	methods: {
	}
}
</script>
<style lang="less">
.yl_dataCensus_title{
	padding-bottom: 16px;
	font-size: 14px;
	font-weight: bold;
	color: #000000;
	line-height: 22px;
	border-bottom: 1px solid #F2F2F2;
	margin-bottom: 22px;
}
.yl_dataCensus{
	.dataCensus_li{
		padding: 10px 0;
		.census_box{
			padding: 0 20px;
			border-left: 1px solid #E8E8E8;
			.census_describe{
				color: #909399;
				font-size: 14px;
				line-height: 22px;
			}
			.census_data{
				font-size: 24px;
				font-weight: bold;
				color: #303133;
				line-height: 31px;
			}
		}
		&:nth-of-type(1){
			.census_box{
				border-left: none;
			}
		}
	}
}
</style>